module.exports = {
  lang: {
    t1: "Startseite",
    t2: "Visitenkarte",
    t3: "Folgen",
    t4: "Kontakte",
    t5: "Nachrichten",
    t6: "Anmelden",
    t7: "Registrieren",
    t8: "Neue globale Geschäftsvernetzungsplattform, neues Feld für das digitale Marketing von Unternehmen",
    t9: "WeMeet - Anmeldung mit Mobilfunknummer",
    t10: "Mobilfunknummer",
    t11: "Bestätigungscode",
    t12: "Bitte geben Sie Ihre Mobilfunknummer ein",
    t13: "Bitte geben Sie den Bestätigungscode ein",
    t14: "Erhalten",
    t15: "Anmeldung",
    t16: "Bitte geben Sie die korrekte Format des Mobilfunknummer ein",
    t17: "Der Verifizierungscode wurde gesendet",
    t18: "Der eingegebene Verifizierungscode ist falsch. Bitte überprüfen und erneut eingeben.",
    t19: "Anmeldung erfolgreich",
    t20: "Ihr Verifizierungscode ist (0). Bitte verwenden Sie ihn innerhalb von {1} Minute(n).",
    t21: "Abbrechen",
    t22: "Bestätigen",
    t23: "Wichtige Hinweise",
    t24: "Ihre WeMeet-Konto-Registrierung ist noch nicht abgeschlossen. Handeln Sie jetzt, um den Registrierungsprozess abzuschließen und von vielfältigen Interaktionen und unendlichen Möglichkeiten zu profitieren.",
    t25: "Zum Registrieren wechseln",
    t26: "WeMeet-E-Mail-Anmeldung",
    t27: "Kontoname",
    t28: "Geben Sie Ihre E-Mail-Adresse ein",
    t29: "Passwort",
    t30: "Geben Sie Ihr Passwort ein",
    t31: "Passwort vergessen?",
    t32: "Einloggen",
    t33: "Andere Loginmethoden",
    t34: "Bereits für die WeMeet Mini-App registriert? Nutzen Sie sie jetzt.",
    t35: "Mit Telefonnummer anmelden",
    t36: "Bitte geben Sie zuerst Ihre E-Mail-Adresse ein.",
    t37: "Bitte geben Sie zuerst Ihr Passwort ein.",
    t38: "Die E-Mail-Adresse hat ein ungültiges Format",
    t39: "Wenn Sie bereits über ein WeMeet-Konto verfügen, können Sie sich direkt anmelden",
    t40: "Einloggen",
    t41: "Profilbild",
    t42: "Bitte laden Sie ein echtes Profilbild hoch",
    t43: "vollständiger Name",
    t44: "Vorname",
    t45: "Nachname",
    t46: "Organisationsname",
    t47: "Bitte geben Sie den Namen Ihrer Institution an",
    t48: "Position",
    t49: "Bitte geben Sie den Titel Ihrer Stellung innerhalb der Institution an",
    t50: "E-Mail",
    t51: "Geben Sie Ihre E-Mail-Adresse ein",
    t52: "Mobilfunknummer",
    t53: "Bitte geben Sie Ihre Mobilfunknummer ein",
    t54: "Region",
    t55: "Bitte wählen Sie eine Region aus",
    t56: "Zone",
    t57: "Bitte wählen Sie Bundesland, Stadt und Bezirk aus",
    t58: "Adresse",
    t59: "Bitte geben Sie Ihre Adresse ein",
    t60: "Ich habe die Nutzungsbedingungen und Datenschutzrichtlinien von WeMeet gelesen und stimme ihnen zu.",
    t61: "Nutzungsbedingungen",
    t62: "Datenschutzrichtlinie",
    t63: "Weiter",
    t64: "Bitte zuerst die Benutzervereinbarung ankreuzen",
    t65: "Bitte geben Sie Ihren Namen ein",
    t66: "Bitte geben Sie Ihren Nachnamen ein",
    t67: "Bitte zuerst Ihre E-Mail-Adresse eingeben",
    t68: "Bitte zuerst den Namen Ihrer Organisation eingeben",
    t69: "Die E-Mail-Adresse hat ein ungültiges Format",
    t70: "Abbrechen",
    t71: "Vollständig machen",
    t72: "Mobilnummer überprüfen",
    t73: "Mobilfunknummer",
    t74: "Bestätigungscode",
    t75: "Bitte geben Sie den Bestätigungscode ein",
    t76: "Erhalten",
    t77: "Überprüfung überspringen",
    t78: "Übermitteln",
    t79: "Verifiziert",
    t80: "Der eingegebene Verifizierungscode ist falsch. Bitte überprüfen und erneut eingeben.",
    t81: "Übersprungen",
    t82: "Wichtige Hinweise",
    t83: "Die von Ihnen eingegebene Telefonnummer ist bereits mit einem WeMeet-Konto registriert. Es ist nicht notwendig, sich erneut zu registrieren. Bitte melden Sie sich jetzt an.",
    t84: "Zum Anmelden wechseln",
    t85: "Wichtige Hinweise",
    t86: "Die von Ihnen eingegebene E-Mail-Adresse ist bereits mit einem WeMeet-Konto registriert. Es ist nicht notwendig, sich erneut zu registrieren. Bitte melden Sie sich jetzt an.",
    t87: "Zum Anmelden wechseln",
    t88: "Ein Bestätigungslink wurde gesendet.",
    t89: "Bitte überprüfen Sie Ihre E-Mails und klicken Sie auf den Link, um die Registrierung abzuschließen.",
    t90: "Verstanden",
    t91: "Willkommen bei WeMeet",
    t92: "Willkommen bei WeMeet! Bitte klicken Sie auf die Schaltfläche, um Ihre Registrierung abzuschließen. Freundliche Erinnerung: Dieser Link ist 24 Stunden lang gültig, bitte handeln Sie schnell.",
    t93: "Registrierung abgeschlossen",
    t94: "Ihre E-Mail-Adresse wurde aktiviert. Bitte geben Sie Ihr Passwort ein.",
    t95: "Passwort eingeben",
    t96: "Geben Sie Ihr Passwort ein",
    t97: "Passwort bestätigen",
    t98: "Bitte geben Sie Ihr Passwort erneut ein",
    t99: "Muss eine Kombination aus Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten und zwischen 8 und 20 Zeichen lang sein",
    t100: "Geben Sie Ihr Passwort ein",
    t101: "Bitte geben Sie Ihr Passwort erneut ein",
    t102: "Die Passwörter stimmen nicht überein",
    t103: "Herzlichen Glückwunsch zur abgeschlossenen Registrierung",
    t104: "Sie sind nun bei WeMeet angemeldet und können mit Ihren vorherigen Aktionen fortfahren.",
    t105: "Setzen Sie Ihre Erfahrung fort",
    t106: "Wichtige Hinweise",
    t107: "Der Link ist abgelaufen. Bitte klicken Sie auf die Schaltfläche, um ihn erneut abzurufen.",
    t108: "Erneut senden",
    t109: "Nutzungsbedingungen",
    t110: "Datenschutzerklärung",
    t111: "Passwort zurücksetzen",
    t112: "Bitte geben Sie das Konto an, für das Sie das Passwort zurücksetzen möchten",
    t113: "Kontoname",
    t114: "Geben Sie Ihre E-Mail-Adresse ein",
    t115: "Übermitteln",
    t116: "Bitte geben Sie zuerst Ihre E-Mail-Adresse ein.",
    t117: "Die E-Mail-Adresse hat ein ungültiges Format",
    t118: "E-Mail gesendet",
    t119: "Bitte überprüfen Sie Ihre E-Mail, klicken Sie auf den Link und setzen Sie Ihr Passwort zurück.",
    t120: "Verstanden",
    t121: "Passwort zurücksetzen - WeMeet",
    t122: "Ihre Anfrage zum Zurücksetzen des Passworts wurde bestätigt, und das System hat einen temporären Link für das Zurücksetzen des Passworts generiert. Freundliche Erinnerung: Dieser Link ist 24 Stunden lang gültig, bitte handeln Sie schnell.",
    t123: "Passwort zurücksetzen",
    t124: "Passwort zurücksetzen erfolgreich",
    t125: "Sie sind bei WeMeet angemeldet. Willkommen zurück.",
    t126: "Zur Startseite",
    t127: "Kontakte",
    t128: "Neue Kontaktaufnahme",
    t129: "Zustimmen",
    t130: "Ignorieren",
    t131: "Genehmigt",
    t132: "Ignoriert",
    t133: "Folgen",
    t134: "Gefolgt",
    t135: "Nachrichten",
    t136: "Offene Anfrage",
    t137: "Bitte geben Sie Ihren Namen oder Ihre Telefonnummer ein",
    t138: "Keine passenden Inhalte gefunden",
    t139: "Es gibt keine weiteren Einträge mehr",
    t140: "Kontaktanfrage",
    t141: "Zustimmen",
    t142: "Ignorieren",
    t143: "Genehmigt",
    t144: "Ignoriert",
    t145: "WeMeet KI-Raum",
    t146: "Folge",
    t147: "Nicht mehr folgen",
    t148: "vCard",
    t149: "Verbinden",
    t150: "Nachricht senden",
    t151: "Warten auf Freischaltung",
    t152: "Kontakt entfernen",
    t153: "Persönliche Vorstellung",
    t154: "Persönliches Profil",
    t155: "Wichtige Hinweise",
    t156: "Ihre Kontaktanfrage wurde versendet. Nach Genehmigung werden Sie automatisch diesem Benutzer folgen. Alternativ können Sie sich jetzt für ihn entscheiden, um mehr über ihn zu erfahren.",
    t157: "Nicht jetzt folgen",
    t158: "Folgen",
    t159: "Folge",
    t160: "Kontakbeziehung aufheben",
    t161: "Nach dem Entfernen der Kontaktperson kann der andere Teilnehmer Ihre persönlichen Informationen nicht mehr einsehen, wird jedoch nicht automatisch von Ihnen abgemeldet.",
    t162: "Überdenken Sie es nochmal",
    t163: "Kontakt entfernen",
    t164: "Vorgang erfolgreich",
    t165: "WeMeet AI-Assistent",
    t166: "Bitte geben Sie Ihre Frage ein",
    t167: "Senden",
    t168: "Beachten Sie, dass der Inhalt der Interaktion mit der KI möglicherweise ungenau ist und nicht die Perspektive der Plattform wiedergibt.",
    t169: "Visitenkarte von WeMeet",
    t170: "Herunterladen",
    t171: "Visitenkarte bearbeiten",
    t172: "QR-Code herunterladen",
    t173: "Das Bild wurde generiert. Bitte speichern Sie es. Scannen Sie den QR-Code, um den Kontakt zu speichern.",
    t174: "Profilbild",
    t175: "Bitte laden Sie ein echtes Profilbild hoch",
    t176: "vollständiger Name",
    t177: "Vorname",
    t178: "Nachname",
    t179: "Bitte geben Sie Ihren Namen ein",
    t180: "Organisationsname",
    t181: "Bitte geben Sie den Namen Ihrer Institution an",
    t182: "Position",
    t183: "Bitte geben Sie den Titel Ihrer Stellung innerhalb der Institution an",
    t184: "E-Mail",
    t185: "Geben Sie Ihre E-Mail-Adresse ein",
    t186: "Mobilfunknummer",
    t187: "Bitte geben Sie Ihre Mobilfunknummer ein",
    t188: "Region",
    t189: "Bitte wählen Sie eine Region aus",
    t190: "Zone",
    t191: "Bitte wählen Sie Bundesland, Stadt und Bezirk aus",
    t192: "Adresse",
    t193: "Bitte geben Sie Ihre Adresse ein",
    t194: "Bitte geben Sie Ihren Namen ein",
    t195: "Bitte geben Sie Ihren Nachnamen ein",
    t196: "Bitte zuerst Ihre E-Mail-Adresse eingeben",
    t197: "Bitte zuerst den Namen Ihrer Organisation eingeben",
    t198: "Die E-Mail-Adresse hat ein ungültiges Format",
    t199: "Chatraum",
    t200: "Fotogalerie",
    t201: "Ein Foto machen",
    t202: "Bitte geben Sie Ihre Nachricht ein",
    t203: "Senden",
    t204: "Gelesen",
    t205: "Ungelesen",
    t206: "Widerrufsfrist abgelaufen",
    t207: "Abbrechen",
    t208: "Foto",
    t209: "Album",
    t210: "Aufnehmen",
    t211: "Aus dem Album auswählen",
    t212: "Abbrechen",
    t213: "Foto",
    t214: "Porträt",
    t215: "Vorschau",
    t216: "Vollständig machen",
    t217: "WeMeet AI Raum",
    t218: "Kontaktieren Sie uns",
    t219: "Bitte kontaktieren Sie mich",
    t220: "vollständiger Name",
    t221: "Organisation",
    t222: "Position",
    t223: "Telefon",
    t224: "E-Mail",
    t225: "Region",
    t226: "Zone",
    t227: "Adresse",
    t228: "Bitte geben Sie Ihren Namen ein",
    t229: "Bitte geben Sie den Namen Ihrer Organisation ein",
    t230: "Bitte geben Sie Ihre Position an",
    t231: "Bitte geben Sie Ihre Telefonnummer ein",
    t232: "Bitte geben Sie Ihre E-Mail-Adresse an",
    t233: "Bitte wählen Sie eine Region aus",
    t234: "Bitte wählen Sie Bundesland, Stadt und Bezirk aus",
    t235: "Bitte geben Sie eine Adresse ein",
    t236: "Absicht",
    t237: "Produkte kaufen",
    t238: "Agenturprodukte",
    t239: "Marktzusammenarbeit",
    t240: "Andere",
    t241: "Bitte geben Sie Ihren Namen ein",
    t242: "Bitte geben Sie den Namen Ihrer Organisation ein",
    t243: "Bitte geben Sie Ihre E-Mail-Adresse an",
    t244: "Die E-Mail-Adresse hat ein ungültiges Format",
    t245: "Nachricht wurde übermittelt",
    t246: "Eine Nachricht hinterlassen",
    t247: "Bitte geben Sie den Inhalt Ihrer Anfrage ein",
    t248: "Bestätigen",
    t249: "Bitte erst anmelden oder registrieren",
    t250: "Follower",
    t251: "Kontaktieren Sie uns",
    t252: "Produkte",
    t253: "Team",
    t254: "Überblick",
    t255: "Album",
    t256: "Qualifikation",
    t257: "Stammkapital",
    t258: "Gründungsdatum",
    t259: "Registrierte Adresse",
    t260: "Upstream",
    t261: "Midstream",
    t262: "Downstream",
    t263: "İlgili endüstriler",
    t264: "Verfahren",
    t265: "Speichern",
    t266: "Verifiziert",
    t267: "Chinesisch",
    t268: "Englisch",
    t269: "Französisch",
    t270: "Russisch",
    t271: "Spanisch",
    t272: "Japanisch",
    t273: "Koreanisch",
    t274: "Indonesisch",
    t275: "Vietnamesisch",
    t276: "Deutsch",
    t277: "Türkisch",
    t278: "Italienisch",
    t279: "Portugiesisch",
    t280: "Thailändisch",
    t281: "Malaysisch",
    t282: "Arabisch",
    t283: "Falscher Benutzername oder Passwort",
    t284: "Bitte lesen und akzeptieren Sie zuerst die WeMeet-Nutzungsbedingungen",
    t285: "Keine relevanten Inhalte verfügbar",
    t286: "Typ",
    t287: "Eigenschaft",
    t288: "Details",
    t289: "Andere",
    t290: "Insgesamt 2 Produkte",
    t291: "{1} lädt Sie ein, den WeMeet AI Space von {2} zu besuchen",
    t292: "Klicken Sie hier für ein Beispiel oder geben Sie eine Frage ein:",
    t293: "Aktualisieren",
    t294: "Sie können auch auf die Visitenkarte unten klicken, um Kontakte hinzuzufügen und weitere Informationen zu erhalten:",
    t295: "Lernen",
    t296: "WeMeet Digitale Meetings",
    t297: "WeMeet Digitale Ausstellungen",
    t298: "Danh thiếp và Không gian WeMeet AI",
    t299: "Wie werde ich Mitglied einer WeMeet Organisation",
    t300: "WeMeet Digitale Konferenzdienste bieten Ihnen eine umfassende Lösung für Online-Meetings, einschließlich der Erstellung und Veröffentlichung von Meetings, der Verwaltung der Registrierung von Teilnehmern, des elektronischen Check-ins, der Terminplanung von Meetings, des Austauschs von Meetingmaterialien, der Echtzeit-Interaktion und der Gästeinteraktionen.",
    t301: 'WeMeet Digitale Ausstellung, die hilft, schnell eine Mikro-Offizielle Ausstellungswebsite aufzubauen. Zeigen Sie Ausstellerinformationen, Ausstellungsbeschreibungen, Live-Ausstellungsübertragungen, Ausstellungsregistrierung, Veranstaltungspläne und mehr, um teilnehmenden Unternehmen und Zuschauern zu ermöglichen, die Ausstellungsdetails leicht zu verstehen. Um die WeMeet Digital Exhibition-Funktion zu nutzen, bitte zuerst den institutionellen Eintrittsprozess abschließen. Klicken Sie auf "Mein", scrollen Sie nach unten zum "Service Center" - "Institutioneller Eintritt" und folgen Sie den Anweisungen, um den Eintrittsprozess abzuschließen.',
    t302: "WeMeet-Personalbenutzer müssen nur ihre WeChat-ID, Telefonnummer autorisieren und die Plattformregistrierung abschließen, um eine persönliche digitale Visitenkarte zu erhalten und ihre persönliche AI-Lounge (einschließlich persönlichem Lebenslauf, Updates, Fotos, Dokumenten usw.) zu pflegen.",
    t303: 'Klicken Sie auf die Option "Mein" in der unteren Menüleiste des Mini-Programms, um die persönliche Visitenkartenseite zu aktualisieren und die persönliche Homepage zu verbessern.',
    t304: "Kombination aus Groß- und Kleinbuchstaben, Zahlen und Satzzeichen mit einer Länge zwischen 8 und 20 Zeichen.",
    t305: "Geben Sie den Produktnamen ein",
    t306: "Keine weiteren Artikel",
    t307: "Klicken Sie oben rechts",
    t308: "Wählen Sie Ihren bevorzugten Freigabeweg",
    t309: "Ich verstehe",
    t310: "Bitte registrieren und einloggen Sie sich zuerst",
    t311: "Mehr erfahren",
    t312: "Verwandte Produkte",
    t313: "Vielen Dank für Ihren Besuch",
    t314: "Abmelden",
    t315: "Gefolgte Organisationen",
    t316: "Vorherige",
    t317: "Nächste",
    t318: "Keine",
    t319: "{1} lädt Sie ein, {2} zu besuchen",
    t320: "AI Lounge hat die aktuelle Sprache nicht gepflegt",
    t321: "AI Lounge hat auf die aktuelle Sprache umgeschaltet",
    t322: "Der Link wurde aktiviert",
    t323: "Das Netzwerk ist beschäftigt, bitte versuchen Sie es später erneut",
    t324: "Produktdetails wurden in die aktuelle Sprache umgeschaltet",
    t325: "Produktdetails werden derzeit nicht in dieser Sprache gepflegt",
    t326: "Hallo, ich bin der intelligente AI-Assistent von WeMeet, bereit, Ihnen jederzeit einen aufmerksamen Service zu bieten! Wie kann ich Ihnen helfen?",
    t327: "Geben Sie einen Namen ein",
    t328: "Ich habe die relevanten Kontaktinformationen gefunden, bitte überprüfen Sie die Kontaktkarte unten.",
    t329: "Anhang",
    t330: "Ich habe die relevanten Kontaktdaten nicht gefunden.",
    t331: "Ich habe Ihre Anfrage an den unten verantwortlichen Kollegen weitergeleitet; Sie können auch auf die Visitenkarte klicken, um sofort Kontakt aufzunehmen.",
    t332: "Ausstellung",
    t333: "Bitte eingeben",
    t334: "Benutzer",
    t335: "Keine weiteren Artikel",
    t336: "Aktualisierung erfolgreich",
    t337: "Laden",
    t338: "Freigeben zum Aktualisieren",
  },
};
// 德语
